import axios from 'axios';

const accountID = 5; // Account ID for CJC

// Configure axios to automatically add authentication headers
axios.interceptors.request.use(
  (config) => {
    // Check if we have participant auth in sessionStorage
    const participantAuth = sessionStorage.getItem('participantAuth');
    
    if (participantAuth) {
      try {
        const auth = JSON.parse(participantAuth);
        
        if (auth.authToken && auth.authToken.Token) {
          // Use Token scheme for authenticated participant requests
          config.headers.Authorization = `Token ${auth.authToken.Token}_${accountID}`;
        }
      } catch (error) {
        console.error('Failed to parse participant auth:', error);
      }
    } else {
      // Fallback to Bearer token if no participant auth
      config.headers.Authorization = `Bearer ${accountID}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Optional: Add response interceptor to handle auth errors
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      sessionStorage.removeItem('participantAuth');
      // Optionally redirect to login
      if (window.location.pathname.startsWith('/race/')) {
        window.location.href = '/race/login';
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
